module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "p-t-sm"
  }, [_c('div', {
    staticClass: "container clearfix company"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "slider hide"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        'path': '/company/dashboard'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_vm._v("控制台")]), _vm._v(" "), (_vm.user.category === 2) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        'path': '/company/organizations'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_vm._v("组织机构")]) : _vm._e(), _vm._v(" "), (_vm.user.category === 2) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        'path': '/company/hr'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_vm._v("HR管理")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        'path': '/company/posts'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_vm._v("岗位管理")]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        'path': '/company/invitations'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_vm._v("测评邀请")]), _vm._v(" "), (_vm.user.category === 2) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        'path': '/company/setting'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_vm._v("企业设置")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content m-t-sm",
    staticStyle: {
      "min-height": "520px"
    }
  }, [_c('router-view')], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "compare-bar",
    class: {
      show: _vm.showCompare == 1
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bar-title clearfix"
  }, [_c('div', {
    staticClass: "tab current"
  }, [_vm._v("\n                    对比栏\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "tab right small color-default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.hideBar()
      }
    }
  }, [_vm._v("\n                    隐藏\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "bar-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-10 col-xs-12"
  }, [_c('ul', {
    staticClass: "row resumes"
  }, _vm._l((_vm.resumes), function(resume, ind) {
    return _c('li', {
      key: resume.code,
      staticClass: "list-item col-xs-12 col-sm-3"
    }, [(resume.code) ? _c('div', [_c('div', {
      staticClass: "p-b-xs"
    }, [_vm._v(_vm._s(resume.user.realname))]), _vm._v(" "), _c('div', {
      staticClass: "p-b-xs"
    }, [_vm._v(_vm._s(resume.user.phone))]), _vm._v(" "), _c('div', {
      staticClass: "p-b-xs"
    }, [_vm._v(_vm._s(resume.post))]), _vm._v(" "), _c('div', {
      staticClass: "p-b-xs"
    }, [_vm._v(_vm._s(resume.score) + "分")]), _vm._v(" "), _c('div', {
      staticClass: "text-right"
    }, [_c('a', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.delResume(ind)
        }
      }
    }, [_vm._v("\n                                            删除\n                                        ")])])]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "row p-t-b-sm"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-12 p-t-b-sm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-sm",
    class: {
      'btn-primary': _vm.compareIds, 'btn-disabled': !_vm.compareIds
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.compareIds
    },
    on: {
      "click": function($event) {
        _vm.compare()
      }
    }
  }, [_vm._v("对比")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-12 p-t-b-sm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('a', {
    staticClass: "tab small color-default",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.clearBar
    }
  }, [_vm._v("\n                                        清空对比栏\n                                    ")])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23b22639","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/company.vue
// module id = 467
// module chunks = 1